import { render, staticRenderFns } from "./SupportedDanceKindsQuery.vue?vue&type=template&id=ac2cf1e2&lang=pug"
import script from "./SupportedDanceKindsQuery.vue?vue&type=script&lang=js"
export * from "./SupportedDanceKindsQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports